export * from './gs-input-clipboard.component';
